import React, { useEffect } from 'react';
import './App.css';
import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Division from './pages/Division';
import ServiceDetail from './pages/ServiceDetail';
import CodiceEtico from './pages/CodiceEtico';
import CaseStudyDetail from './pages/CaseStudyDetail';

function ScrollManager() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace('#', ''));
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [location.pathname, location.hash]);

  return null;
}

function App() {
  return (
    <div className="App">
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/codice-etico" element={<CodiceEtico />} />
        <Route path="/portfolio/:caseSlug" element={<CaseStudyDetail />} />
        <Route path="/divisione-energia" element={<Division slug="divisione-energia" />} />
        <Route path="/divisione-energia/:serviceSlug" element={<ServiceDetail divisionSlug="divisione-energia" />} />
        <Route path="/divisione-manutenzione" element={<Division slug="divisione-manutenzione" />} />
        <Route path="/divisione-manutenzione/:serviceSlug" element={<ServiceDetail divisionSlug="divisione-manutenzione" />} />
        <Route path="/consulting" element={<Division slug="consulting" />} />
        <Route path="/revamping" element={<Division slug="revamping" />} />
        <Route path="/costruzioni" element={<Division slug="costruzioni" />} />
        <Route path="/risparmio-energetico" element={<Division slug="risparmio-energetico" />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </div>
  );
}

export default App;
